import styled from "styled-components";

export const Container = styled.div`
    display:flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
`;

export const ButtonsStatusContainer = styled.div`
    position: absolute;
    display: flex;
    flex-direction: column;
    gap: 10px;
`;

export const ButtonStatus = styled.button`
    background: transparent;
    border: none;
    color: ${(props)=> props.color};
    cursor: pointer;
    font-size: 32px;  
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    outline: none;
    text-align: center;
    z-index: 10;
    @media (min-width: 720px) {
        font-size: 48px;
    }
    @media (orientation: landscape) and (max-width: 1080px){
        font-size: 32px;
    }
`;